/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Rep_Max_NoteInputs */

const en_us2_exercise_sheet_rep_max_note = /** @type {(inputs: Exercise_Sheet_Rep_Max_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done: the heaviest weight you have used in a set of at least that many reps. Estimated: what you could probably manage, worked out from your max strength.`)
};

const pt_br2_exercise_sheet_rep_max_note = /** @type {(inputs: Exercise_Sheet_Rep_Max_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito: o maior peso que você já usou numa série com pelo menos essas repetições. Estimado: quanto você provavelmente aguentaria, calculado da sua força máxima.`)
};

const es_419_exercise_sheet_rep_max_note = /** @type {(inputs: Exercise_Sheet_Rep_Max_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho: el mayor peso que has usado en una serie de al menos esas repeticiones. Estimado: lo que probablemente podrías hacer, calculado a partir de tu fuerza máxima.`)
};

const pt_pt2_exercise_sheet_rep_max_note = /** @type {(inputs: Exercise_Sheet_Rep_Max_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito: o maior peso que já usaste numa série com pelo menos essas repetições. Estimado: quanto provavelmente aguentarias, calculado a partir da tua força máxima.`)
};

const fr_fr2_exercise_sheet_rep_max_note = /** @type {(inputs: Exercise_Sheet_Rep_Max_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réalisé : la charge la plus lourde que tu as utilisée sur une série d'au moins ce nombre de répétitions. Estimé : ce que tu pourrais probablement faire, calculé à partir de ta force max.`)
};

const de_de2_exercise_sheet_rep_max_note = /** @type {(inputs: Exercise_Sheet_Rep_Max_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschafft: das höchste Gewicht, das du in einem Satz mit mindestens so vielen Wiederholungen genutzt hast. Geschätzt: was du wahrscheinlich schaffen würdest, berechnet aus deiner Maximalkraft.`)
};

const it_it2_exercise_sheet_rep_max_note = /** @type {(inputs: Exercise_Sheet_Rep_Max_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto: il peso più alto che hai usato in una serie di almeno quelle ripetizioni. Stimato: quanto probabilmente reggeresti, calcolato dalla tua forza massima.`)
};

/**
* | output |
* | --- |
* | "Done: the heaviest weight you have used in a set of at least that many reps. Estimated: what you could probably manage, worked out from your max strength." |
*
* @param {Exercise_Sheet_Rep_Max_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_rep_max_note = /** @type {((inputs?: Exercise_Sheet_Rep_Max_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Rep_Max_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_rep_max_note(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_rep_max_note(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_rep_max_note(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_rep_max_note(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_rep_max_note(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_rep_max_note(inputs)
	return en_us2_exercise_sheet_rep_max_note(inputs)
});
export { exercise_sheet_rep_max_note as "exercise-sheet.rep_max_note" }